import "./Contect.css";
import Phone  from "../../img/phone.png";
import Email  from "../../img/email.png";
import Address  from "../../img/address.png";
import { useRef, useState } from "react";
import emailjs from '@emailjs/browser';



const Contect = () => {


    const formRef=useRef();
    const [done,setDone]=useState(false);

   const handleSubmit=(e)=>{

    e.preventDefault();
    emailjs.formRef('service_ol0vwrq', 'template_ae26npc', formRef.current, 'user_qu2hso8Hnbg7ttkJczeIR')
    .then((result) => {
        console.log(result.text);
        setDone(true)
    }, (error) => {
        console.log(error.text);
    });
   };

  
  
    


  

















    return (
        <div  className="c">
            <div  className="c-bg">   


            </div>

            <div  className="c-wrapper">

                <div className="c-left">

 <h1  className="c-title"> Let's Discuss your Project </h1>
  <div  className="c-info">



 <div  className="c-info-item">


<img src={Phone}  alt="" className="c-icon"  />
  +91 8155901304


 </div>


 <div  className="c-info-item">


<img src={Email}  alt="" className="c-icon"  />
  + Kunalsolanki@gmail.com


 </div>

 
 <div  className="c-info-item">


<img src={Address}  alt="" className="c-icon"  />
54,shanti magal park socity new sma road vadodara  society vadodara gujarat india
 

 </div>




  </div>
                </div>
                
                <div className="c-right">
                <p className="c-desc">
            <b>What’s your story?</b> Get in touch. Always available for
            freelancing if the right project comes along. me.
          </p>
          

          <form    ref={formRef}  onSubmit={handleSubmit} >

          <input  type="text"   placeholder="Name"  name="user_name"/>
          <input  type="text"   placeholder="Subject"  name="user_subject"/>
          <input type="text"   placeholder="Email"  name="user_email"/>
          <textarea    rows="5"   placeholder="Massage" name="user_massge"/>

          <button>Submit</button>
        { done && "thank you..."}


         </form>



                </div>
            </div>
        </div>
    )
}

export default Contect;
